import { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthProvider';
import { Navigate, Outlet } from 'react-router-dom';
import { validateToken } from '../http/api';
import { useGlobalState } from '../Context/GlobalContext';

const SessionRoute = () => {
  const { isLoggedIn, token } = useAuth();
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const {tgRoute} = useGlobalState();
  const tRoute = `/${tgRoute}`;
  
  useEffect(() => {
    
    const check = async () => {
      if (isLoggedIn && token) {
        const isValid = await validateToken(token);
        setValid(isValid);
      }
      setChecking(false);
    };
    check();
  }, [isLoggedIn, token]);

  if (checking) return null;
  if (isLoggedIn && valid) return <Navigate to={tRoute} />;
  return <Outlet />;
};

export default SessionRoute;
